import { Route, Routes } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Login } from "../pages/Login";

export function AuthRoutes() {
  return (
    <>
      <Helmet>
        <title>Gestão</title>‍
        <meta name="description" content="" />
      </Helmet>
      <Routes>
        <Route path="/" element={<Login />} />
      </Routes>
    </>
  );
}
